// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"5a3c9967","25":"097bd134","56":"4fb9cefa","267":"1aec6f21","468":"83889edb","896":"f7faf509"}[chunkId] + ".chunk.js";
};